module.exports = __webpack_public_path__ + "assets/img/idcard_front.9bd1d6dc.png";